module.exports = __webpack_public_path__ + "a6b12352473125c6365740d152b8df54.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/2019/payment-generic.svg
// module id = 1504
// module chunks = 1 5 7 8 15 80